module.exports = __webpack_public_path__ + "static/img/61-1.6c7bcd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61-1.jpg
// module id = MaWV
// module chunks = 0